import { partyMonthListApi } from "../../api/partyMonth/partyMonthListApi"

type PayloadShape = Parameters<typeof partyMonthListApi>[0]

export async function partyMonthListService(payload: PayloadShape, token: string | null) {
	return await partyMonthListApi(payload, token)
}
